var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82019 0.565106C4.99146 0.383043 5.2765 0.383043 5.45375 0.565106C5.62502 0.741018 5.62502 1.03379 5.45375 1.2093L2.24123 4.50898H12.8421C13.0892 4.50939 13.2856 4.71114 13.2856 4.96496C13.2856 5.21878 13.0892 5.42709 12.8421 5.42709H2.24123L5.45375 8.72062C5.62502 8.90269 5.62502 9.19587 5.45375 9.37138C5.2765 9.55344 4.99106 9.55344 4.82019 9.37138L0.847157 5.29054C0.669904 5.11463 0.669904 4.82185 0.847157 4.64635L4.82019 0.565106Z",
    fill: "#002364"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.322deafde0fe7799d4e4bcc556f84a86.svg";
export { ForwardRef as ReactComponent };